<template>
    <div>
        <HeaderStock header="คลัง" :img_header="header_image" link_back="stock" />
        <MenuStockList/>
        <StockReportList/>
    </div>
</template>

<script>
import HeaderImage from '@/assets/icon-stock.png'
import HeaderStock from '@/components/menuadmin/stock/stockheader/HeaderStock.vue'
import MenuStockList from '@/components/menuadmin/stock/stocklist/MenuStockList.vue'
import StockReportList from '@/components/menuadmin/stock/stocklist/StockReportList.vue'
export default {
    name:'stockReport',
    components:{
        HeaderStock,
        MenuStockList,
        StockReportList,
    },
    data(){
        return{
            header_image:HeaderImage
        }
    }
}
</script>